import React from "react";
import { lib } from "react-single-app";
import "./header.less";
import { withRouter } from "react-router";
import { LogoutOutlined, UserOutlined, CloudDownloadOutlined } from "@ant-design/icons";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: {},
        };
    }
    componentDidMount() {
        lib.request({
            url: "/ucenter-account/current/userInfo",
            success: res => {
                this.setState({
                    userInfo: res,
                });
            },
        });
    }
    logout() {
        let rootPath = lib.config.webToken == "admin" ? "/login-admin" : "/login";
        lib.request({
            url: "/ucenter-account/logout",
            data: { systemCode: "LOGIN" },
            success: res => {
                this.props.history.push(`${rootPath}/login`);
            },
        });
    }
    render() {
        const { userInfo } = this.state;
        let rootPath = lib.config.webToken == "admin" ? "/login-admin" : "/login";
        return (
            <div className="header">
                <div className="user">
                    <div className="name">
                        {userInfo?.userName}
                        <div className="header-tip">
                            <div className="list">
                                <div
                                    onClick={() =>
                                        this.props.history.push(`${rootPath}/personal-center`)
                                    }>
                                    <UserOutlined />
                                    <span>个人中心</span>
                                </div>
                                <div
                                    onClick={() =>
                                        this.props.history.push(
                                            `${rootPath}/download-center?page_title=下载中心`,
                                        )
                                    }>
                                    <CloudDownloadOutlined />
                                    <span>下载中心</span>
                                </div>
                                <div onClick={this.logout.bind(this)}>
                                    <LogoutOutlined />
                                    <span>退出登录</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Header);
